<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Novo Usuário
        </span>
      </h3>
    </div>
    <Form url="/usuario/create" :usuario="usuario" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import UsuariosData from "./UsuariosData";
import { mapGetters } from "vuex";

export default {
  name: "app-usuario-create",
  data() {
    return {
      usuario: new UsuariosData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
